import { useMutation } from '@tanstack/react-query';
import { downloadAttachment } from '../../TimesheetsService';

const useDownloadAttachment = (options) => useMutation(downloadAttachment, options);

export default useDownloadAttachment;
